import axiosServices from "../utils/axios";
import { convertToCamelCase, convertToSnakeCase } from "../utils/code-utils";

import type { ChannelClosure } from "../utils/types/channelClosure";

export const fetchChannelClosureList = async () => {
  const response = await axiosServices.get(`/channelclosure`);
  return convertToCamelCase<ChannelClosure[]>(response.data.data);
};

export const updateChannelClosureData = async (
  id: string,
  data: {
    [key: string]: any;
    channelClosureId: string;
  }
) => {
  const inputData = convertToSnakeCase(data);
  await axiosServices.put(`/channelclosure/${id}`, inputData);
  return {
    success: true,
    data,
  };
};

export const deleteChannelClosureData = async (id: string) => {
  const response = await axiosServices.delete(`/channelclosure/${id}`);
  return { success: response.data.success, id };
};

export const addChannelClosureData = async (data: { [key: string]: any }) => {
  const inputData = convertToSnakeCase(data);
  const response = await axiosServices.post(`/channelclosure`, inputData);
  return convertToCamelCase<ChannelClosure>(response.data.data);
};

export const fetchChannelFilterClosureList = async () => {
  try {
    const response = await axiosServices.get("/channelclosure", {
      params: {
        filter: "date",
        page: 1,
        start: 0,
        limit: 25
      },
    });
    return response.data.data;
  } catch (error) {
    console.error("Error fetching berth rotation data:", error);
    throw error;
  }
};

